import PropTypes from 'prop-types';

import { isResidentRole, isStaffRole } from '../../../../utils';

const VisibleToComponent = ({ personRoleId, isMultiThread }) => {
  let visibleTo = null;
  const isSenderStaff = personRoleId && isStaffRole(personRoleId);
  const isSenderResident = personRoleId && isResidentRole(personRoleId);
  if (isSenderStaff) visibleTo = 'Visible to All';
  if (isSenderResident) visibleTo = 'Visible to Staff Only';
  return isMultiThread && visibleTo ? <div>{visibleTo}</div> : null;
};

VisibleToComponent.defaultProps = {
  personRoleId: null,
};

VisibleToComponent.propTypes = {
  personRoleId: PropTypes.instanceOf(Object),
  isMultiThread: PropTypes.bool.isRequired,
};

export default VisibleToComponent;
